// 引入环境变量
import {ENV} from "../config.js"
// let ENV="DEV"
// 引入request 路径
import {REQUEST_PATH} from "./requestPath"

// request请求 域名命名规范 首字母大写 下划线(_)连接 DOMAIN
// C_DOMAIN  C表示c端   
// A_DOMAIN  A表示架构  
// B_DOMAIN  B表示B端  
// F_DOMAIN  F表示金融端
// O_DOMAIN  O表示未知端
// L_DOMAIN  L表示登录
// S_DOMAIN  S表示验签


// C端接口域名
const C_DOMAIN={
  LOCAL:"//api.dev.tuanche.com",
  DEV:"//t.api.tuanche.com",
  PRE:"//api.test.tuanche.com",
  PROD:"//api.tuanche.com"
}

// B端接口域名
const B_DOMAIN={
  LOCAL:"//manu.dev.tuanche.com/",
  DEV:"//t.manu.tuanche.com/",
  PRE:"//manu.test.tuanche.com/",
  PROD:"https://shangjia.tuanche.com/"
}

// 金融端接口域名
const F_DOMAIN={
  LOCAL:"//finance.dev.tuanche.com",
  DEV:"//t.finance.tuanche.com",
  PRE:"//finance.test.tuanche.com",
  PROD:"//finance.tuanche.com"
}

// 验签接口域名
const S_DOMAIN={
  LOCAL:"//login.dev.tuanche.com/",
  DEV: '//t.login.tuanche.com/',
  PRE: '//login.test.tuanche.com/',
  PROD: '//login.tuanche.com/'
}

/**
 * 靜態資源url
 * @type {{DEV: string, PRE: string, PROD: string}}
 */
const staticEnvUrl={
  LOCAL:"//t.static.tuanche.com/webCommonUtils/dest",
  DEV:" //t.static.tuanche.com/webCommonUtils/dest",
  PRE:"//static.test.tuanche.com/webCommonUtils/dest",
  PROD:"//static.tuanche.com/webCommonUtils/dest"
}

// 静态资源路径
const STATIC_URL={
  LOCAL:"//static.dev.tuanche.com/webCommonUtils/dest",
  DEV:" //t.static.tuanche.com/webCommonUtils/dest",
  PRE:"//static.test.tuanche.com/webCommonUtils/dest",
  PROD:"//static.tuanche.com/webCommonUtils/dest"
}


const picDomain={
  LOCAL:"//pic.tuanche.com",
  DEV: '//pic.tuanche.com',//测试
  PRE: '//pic.tuanche.com',//预发布
  PROD: '//pic.tuanche.com', //发布
}

const staticEevUrls={
  LOCAL:"//static.dev.tuanche.com/",
  DEV:" //t.static.tuanche.com/",
  PRE:"//static.test.tuanche.com/",
  PROD:"//static.tuanche.com/"
}

const pic={
  LOCAL:"//pic.dev.tuanche.com",//开发
  DEV: '//t.pic.tuanche.com',//测试
  PRE: '//pic.test.tuanche.com',//预发布
  PROD: '//pic.tuanche.com', //发布
}


/**
 * 微信授权域名
 */
const wxAuth={
  LOCAL:"//www.dev.pushdana.com",
  DEV: '//t.www.pushdana.com',//测试
  PRE:"//www.test.pushdana.com",
  PROD:"//www.pushdana.com"
}
/**
 * 微信Appid
 */
const APPID={
  LOCAL:"wxc61c7c5ddb8d1318",
  DEV:"wxc61c7c5ddb8d1318",//测试
  PRE:"wxc61c7c5ddb8d1318",
  PROD:"wxc61c7c5ddb8d1318"
}

/*
团车金融项目各个环境域名
 */
const financePATH = {
  LOCAL:"//finance.dev.tuanche.com/m/instalment/",
  DEV: '//t.finance.tuanche.com/m/instalment/',//测试
  PRE:"//finance.test.tuanche.com/m/instalment/",
  PROD:"//finance.tuanche.com/m/instalment/"
}

const financeDomain={
  LOCAL: "//finance.dev.tuanche.com",
  DEV:"//t.finance.tuanche.com",
  PRE:"//finance.test.tuanche.com",
  PROD:"//finance.tuanche.com"
};

/*
买新车项目各个环境域名
 */
const newCarPATH = {
  LOCAL:"//m.dev.tuanche.com/buynewcar/",
  DEV: '//t.m.tuanche.com/buynewcar/',//测试
  PRE:"//m.test.tuanche.com/buynewcar/",
  PROD:"//m.tuanche.com/buynewcar/"
}

/*
买新车项目各个环境域名
 */
const M_TUANCHE_COM = {
  LOCAL:"//m.dev.tuanche.com/",
  DEV: '//t.m.tuanche.com/',//测试
  PRE:"//m.test.tuanche.com/",
  PROD:"//m.tuanche.com/"
}

/*
wap项目各个环境域名
 */
const WAP_TUANCHE_COM = {
  LOCAL:"//wap.dev.tuanche.com/",
  DEV: '//t.wap.tuanche.com/',//测试
  PRE:"//wap.test.tuanche.com/",
  PROD:"//wap.tuanche.com/"
}



const baseUrl=C_DOMAIN[ENV]

const staticUrl=staticEnvUrl[ENV]
// 验签
const signDomain=S_DOMAIN[ENV]
const picBaseUrl=picDomain[ENV]
const picSurl=pic[ENV]

const staticUrls=staticEevUrls[ENV]
const wxAuthUrl=wxAuth[ENV]
const wxAppId=APPID[ENV]
const financePath=financePATH[ENV]
const newCarPath=newCarPATH[ENV]

const mTuancheCom=M_TUANCHE_COM[ENV]

// 如果存在广告对象, 调用设置路径方法 (防止没有对象时报错)
if (window.Advertjs) window.Advertjs.setBaseUrl(baseUrl);

const api={
  ...REQUEST_PATH, // request 请求接口路径
  domain:{
    C_DOMAIN:C_DOMAIN[ENV], //C端接口域名
    B_DOMAIN:B_DOMAIN[ENV], //B端接口域名
    F_DOMAIN:F_DOMAIN[ENV], //F端接口域名
  },
  STATIC_URL:STATIC_URL[ENV],
  WAP_TUANCHE_COM:WAP_TUANCHE_COM[ENV]
  
}

const url={
  financeDomain:financeDomain[ENV],
  baseUrl,
  api,
  staticUrl,
  signDomain,
  picBaseUrl,
  staticUrls,
  wxAuthUrl,
  wxAppId,
  newCarPath,
  financePath,
  mTuancheCom,
  picSurl
}

export {url};



// WEBPACK FOOTER //
// ./static/js/lib/url.js